<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import Qs from 'qs'
    import URL from '@/views/newmis36/util/url'
    import axios from 'axios'

    let gatewayAddress = {"M": "M", "P": "P"};
    let status = {0: "禁用", 1: "启用"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "switch") {
                    this.dataChanage(URL.payment.editStatus, {
                        merchantId: row.merchantId,
                        status: row.status,
                        bankCode: row.bankCode
                    }, res => {
                        if (res.code == 0) {
                            this.$refs.childTable.defaultGetData(this.queryData);
                            this.$message.success(window.$t('mis.faceConfig.updateSuccess'))
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t("common.search") == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                deleteIds: "",
                queryData: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: 'gatewayAddress', field: 'gatewayAddress', type: 2, optionList: gatewayAddress},
                        {title: 'merchantId', field: 'merchantId'},
                        {click: window.$t("common.search")}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.payment.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: 'bankName', field: 'bankName'},
                        {title: 'bankNameTW', field: 'bankNameTw'},
                        {title: 'bankNameEN', field: 'bankNameEn'},
                        {title: 'commonBankCode', field: 'commonBankCode'},
                        {title: 'bankCode', field: 'bankCode'},
                        {title: 'gatewayAddress', field: 'gatewayAddress'},
                        {title: 'gatewayCode', field: 'gatewayCode'},
                        {title: 'depositLimit', field: 'depositLimit'},
                        {title: 'sequence', field: 'sequence'},
                        {title: 'payId', field: 'payId'},
                        {title: 'merchantId', field: 'merchantId'},
                        {
                            title: window.$t('txmis.bt.operation'), btnClick: [{
                                name: (data, full) => {
                                    return status[full.status];
                                }, click: "switch", type: "primary", icon: "el-icon-edit"
                            }]
                        },
                    ]
                }
            }
        }
    }
</script>
